import {ROUTES} from '@/config/routesConstants';

// Match on `error.message === OFF_PLATFORM_INVALID_TOKEN`: error type/status
// don't survive jsonapi-react's rethrow, so the message is the only discriminator.
export const OFF_PLATFORM_INVALID_TOKEN = 'OFF_PLATFORM_INVALID_TOKEN';

// Must match OffPlatformShareTokenAuthenticatable#render_off_platform_unauthorized.
export const OFF_PLATFORM_SHARE_TOKEN_ERROR_TITLE =
  'Off-platform share link is invalid or expired';

export function isOffPlatformShareTokenRejection(errorBody: string): boolean {
  try {
    const json = JSON.parse(errorBody);
    const error = json?.errors?.[0];
    if (typeof error === 'string') {
      return error === OFF_PLATFORM_SHARE_TOKEN_ERROR_TITLE;
    }
    return (
      error?.title === OFF_PLATFORM_SHARE_TOKEN_ERROR_TITLE ||
      error?.detail === OFF_PLATFORM_SHARE_TOKEN_ERROR_TITLE
    );
  } catch {
    return false;
  }
}

export function isOffPlatformPath(
  pathname: string | null | undefined
): boolean {
  if (!pathname) {
    return false;
  }
  return (
    pathname === ROUTES.OFF_PLATFORM_REVIEW ||
    pathname.startsWith(`${ROUTES.OFF_PLATFORM_REVIEW}/`)
  );
}

function getOffPlatformShareTokenFromLocation(): string | null {
  if (!isOffPlatformPath(window.location.pathname)) {
    return null;
  }
  return new URLSearchParams(window.location.search).get('token');
}

export function appendOffPlatformShareTokenToRequestUrl(path: string): string {
  const token = getOffPlatformShareTokenFromLocation();
  if (!token) {
    return path;
  }

  const url = new URL(path, window.location.origin);
  url.searchParams.set('token', token);
  return url.toString();
}
